import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const BlueTickIcon = ({ ariaLabel = 'Tick icon', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <rect x="0.121094" y="0.467529" width="32" height="32" rx="16" fill="#E9F8FF" />
      <g clipPath="url(#clip0_119_5669)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12109 16.4675C8.12109 12.0493 11.7028 8.46753 16.1211 8.46753C20.5394 8.46753 24.1211 12.0493 24.1211 16.4675C24.1211 20.8858 20.5394 24.4675 16.1211 24.4675C11.7028 24.4675 8.12109 20.8858 8.12109 16.4675Z"
          fill="#0091D3"
        />
        <path
          d="M19.1357 13.8437C19.4072 13.5722 19.8475 13.5722 20.119 13.8437C20.3906 14.1153 20.3906 14.5555 20.119 14.827L15.1167 19.8293C14.8452 20.1009 14.405 20.1009 14.1334 19.8293L11.8597 17.5556C11.5881 17.284 11.5881 16.8438 11.8597 16.5722C12.1312 16.3007 12.5714 16.3007 12.843 16.5722L14.6251 18.3544L19.1357 13.8437Z"
          fill="#E9F8FF"
          stroke="white"
          strokeWidth="0.133333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_119_5669">
          <rect width="16" height="16" fill="white" transform="translate(8.12109 8.46753)" />
        </clipPath>
      </defs>
    </svg>
  );
};
